import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=8d23e146&scoped=true&"
import script from "./RegisterCard.vue?vue&type=script&lang=js&"
export * from "./RegisterCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&id=8d23e146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d23e146",
  null
  
)

export default component.exports